import React from 'react';
import { RadioGroup, RadioGroupItem } from '@/ui/radio-group';
import { Label } from '@/ui/label';

interface FrequencySettingsProps {
  scanFrequency: 'per_pr' | 'per_commit';
  setScanFrequency: (frequency: 'per_pr' | 'per_commit') => void;
}

export const FrequencySettings: React.FC<FrequencySettingsProps> = ({
  scanFrequency,
  setScanFrequency,
}) => {
  return (
    <div className="border border-neutral-200 dark:border-neutral-800 p-6 bg-background max-w-3xl mt-8">
      <h4 className="font-mono font-bold uppercase text-sm mb-4">Auto-Review Frequency</h4>
      <RadioGroup value={scanFrequency} onValueChange={(value: 'per_pr' | 'per_commit') => setScanFrequency(value)} className="space-y-4">
        <div className="flex items-start space-x-3 border p-3 hover:bg-neutral-50 dark:hover:bg-neutral-900/20 transition-colors cursor-pointer" onClick={() => setScanFrequency('per_pr')}>
          <RadioGroupItem value="per_pr" id="per_pr" className="mt-1" />
          <div className="flex flex-col space-y-1">
            <Label htmlFor="per_pr" className="font-mono font-bold text-xs uppercase cursor-pointer">
              Once per Pull Request
            </Label>
            <p className="font-mono text-xs text-muted-foreground">
              Review only when PR is opened (default)
            </p>
          </div>
        </div>
        <div className="flex items-start space-x-3 border p-3 hover:bg-neutral-50 dark:hover:bg-neutral-900/20 transition-colors cursor-pointer" onClick={() => setScanFrequency('per_commit')}>
          <RadioGroupItem value="per_commit" id="per_commit" className="mt-1" />
          <div className="flex flex-col space-y-1">
            <Label htmlFor="per_commit" className="font-mono font-bold text-xs uppercase cursor-pointer">
              On Every Commit
            </Label>
            <p className="font-mono text-xs text-muted-foreground">
              Review on every new commit pushed to the PR
            </p>
          </div>
        </div>
      </RadioGroup>
    </div>
  );
};
